__turbopack_context__.v({
  "image1": "MultiImage-module-scss-module__umWkjG__image1",
  "image2": "MultiImage-module-scss-module__umWkjG__image2",
  "image3": "MultiImage-module-scss-module__umWkjG__image3",
  "image4": "MultiImage-module-scss-module__umWkjG__image4",
  "multiImg": "MultiImage-module-scss-module__umWkjG__multiImg",
});
